import { INTERAX_COLORS } from '../../constants/colors'

/**
 * The coach's card surface. Lives here rather than under `features/gamer/pages/ariaCoach` because the
 * preferences section renders on the account-settings and profile pages too — the literal was
 * previously copied into three files.
 */
export const coachCardSx = {
  backgroundColor: INTERAX_COLORS.heritageBlue40,
  border: `1px solid ${INTERAX_COLORS.white10}`,
  borderRadius: 3
}

export const coachCardPaddingSx = { p: { xs: 2, sm: 2.5, md: 3 } }

/** Card surface plus its padding — what most callers want. */
export const coachCardWithPaddingSx = { ...coachCardSx, ...coachCardPaddingSx }

const PILL_RADIUS_PX = 999
const PILL_INSET_PX = 2

/** The pill-shaped segmented control of Aria's mode switch and the coach's focus switch; each passes its own button styling. */
export const buildAriaPillToggleGroupSx = (buttonSx: Record<string, unknown>) => ({
  backgroundColor: INTERAX_COLORS.white08,
  borderRadius: PILL_RADIUS_PX,
  p: `${PILL_INSET_PX}px`,
  gap: `${PILL_INSET_PX}px`,
  '& .MuiToggleButtonGroup-grouped': {
    border: 0,
    borderRadius: `${PILL_RADIUS_PX}px !important`,
    color: INTERAX_COLORS.thunderGrey,
    ...buttonSx,
    '&:hover': { backgroundColor: INTERAX_COLORS.white10 },
    '&.Mui-selected': {
      color: INTERAX_COLORS.offBlack,
      background: INTERAX_COLORS.gradientSun,
      '&:hover': { background: INTERAX_COLORS.gradientSun2 }
    }
  }
})
